import { useState, useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";


import ArticleLayout from "../layouts/baseLayout/ArticleLayout";
import { useDispatch } from "react-redux";
import { setArticleDataToStore } from "../store/ArticleStore";
import ArticleItem from "../components/ArticleItem/ArticleItem";

export default function Article() {
  const { slug } = useParams<{ slug: string }>();
  const { baseUrl } = useSelector((state: RootState) => state.config);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [isDataLoading, setIsDataLoading] = useState(false);
  const [articleData, setArticleData] = useState<any>(null);

  const fetchData = useCallback(async () => {
    setIsDataLoading(true);
    const url = `${baseUrl}/storage/content/news/article.json`;

    try {
      const response = await fetch(url, { method: "GET" });
      const data = await response.json();
      const found = data.find((item: any) => item.articleslug === slug);
      if (found) {
        document.title = 'Artikel - ' + found.title;
        dispatch(setArticleDataToStore([found]));
        setArticleData(found);
      } else {
        setArticleData(null);
      }
    } catch (error) {
      console.log("Error fetching team data:", error);
      setArticleData(null);
    } finally {
      setIsDataLoading(false);
    }
  }, [baseUrl, slug, dispatch]);

  useEffect(() => {
    if (slug) {
      fetchData();
    }
    // Only run when slug or fetchData changes
  }, [fetchData, slug]);

  return (
    <ArticleLayout>
      {isDataLoading ? (
        <h2>{t("loading")}</h2>
      ) : articleData ? (
        <ArticleItem />
      ) : (
        <h2>{t("article_not_found")}</h2>
      )}
    </ArticleLayout>
  );
}
